import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import SVG from "src/utils/SVG";
import { type } from "os";
import cn from "classnames";
import { isEmpty } from "lodash";

interface ICheckBoxProps {
  id: string;
  label?: string | null;
  checked?: boolean;
  readonly?: boolean;
  type?: string;
  className?: string;
  disabled?: boolean;
  pin?: string;
  onChange?: (e: boolean) => void;
}

const CheckBox = (props: ICheckBoxProps) => {
  const { id, type, label, checked, disabled, pin } = props;
  const [isChecked, setIsChecked] = useState(checked || false);
  const [isDisabled, setIsDisabled] = useState(disabled || false);

  useEffect(() => {
    setIsChecked(checked!);
    // if (pin) {
    // }
  }, [props]);

  // const checkBoxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setIsChecked(!isChecked);
  // };

  return (
    <CheckBoxSet>
      <label htmlFor={id} className={cn({ round: type, disabled: isDisabled, checked: isChecked })}>
        {type === "round" ? (
          !isEmpty(pin) ? (
            <SVG name="roundCheckDisabled" width={24} height={24} viewBox="0 0 24 24" />
          ) : isChecked ? (
            <SVG name="roundCheckboxActive" width={25} height={25} viewBox="0.07 -0.4 25 25" />
          ) : (
            <SVG name="roundCheckbox" width={24} height={24} viewBox="0 0 24 24" />
          )
        ) : isChecked ? (
          isDisabled ? (
            <SVG name="checkboxDisabled" width={20} height={20} viewBox="0 0 20 20" />
          ) : (
            <SVG name="checkboxActive" width={20} height={20} viewBox="0 0 20 20" />
          )
        ) : (
          <SVG name="checkbox" width={20} height={20} viewBox="0 0 20 20" />
        )}
        <input
          type="checkbox"
          id={id}
          // checked={isChecked}
          // disabled={isDisabled}
          onChange={(e) => {
            props.onChange && props.onChange!(isChecked);
            // checkBoxHandler(e);
          }}
        />
        {label}
      </label>
    </CheckBoxSet>
  );
};

// CheckBox
const CheckBoxSet = styled.span`
  position: relative;
  display: inline-block;
  ${/* 입력은 1x1 에 clip 으로 숨겨져 있어 포커스 테두리가 그려질 자리가 없다. 그래서
       키보드로 체크박스에 닿아도 표시가 전혀 보이지 않았다(VMD-411 이 되살리려던 바로
       그것이고, 전역 outline 제거와는 다른 원인이다). 표시는 눈에 보이는 label 이 받는다.
       input 이 label 의 자식이라 + 형제 선택자로는 닿지 않으므로 :has 를 쓴다.
       :has 를 모르는 구형 WebView 에서는 이 규칙만 무시되고 나머지는 그대로 동작한다. */ ""}
  label:has(input:focus-visible) {
    outline: 2px solid ${({ theme }) => theme.color.subMain};
    outline-offset: 2px;
  }
  label {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    padding-left: 30px;
    vertical-align: middle;
    > svg {
      position: absolute;
      left: 0;
      top: 0;
    }
    input {
      overflow: hidden;
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      margin: -1px;
      clip: rect(0 0 0 0);
      appearance: none;
    }
    &.round {
      padding-left: 30px;
      color: ${({ theme }) => theme.color.lineSecondary};
      font-family: "Roboto";
      font-weight: 400;
      font-size: 16px;
      &.checked {
        color: ${({ theme }) => theme.color.main};
      }
      > svg {
        top: -3px;
      }
    }
  }
  & + & {
    margin-left: 30px;
  }
`;

export default CheckBox;
